import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { badge, riskColor, zebra } from '../../lib/format';
import { cardPad } from '../../lib/ui';

const CAT_TH: Record<string, string> = { 'Insurance': 'ประกันภัย', 'Automotive Parts': 'ชิ้นส่วนยานยนต์' };
const REG_TH: Record<string, string> = { 'Verified': 'ยืนยันแล้ว', 'Pending': 'รอดำเนินการ' };

export default function Asl() {
  const { go, L } = useApp();

  const asl = [
    { id: 'SUP-001', name: 'Apex Insurance Co.', cat: 'Insurance', tier: 'Tier 1', reg: 'Verified', perf: 92, value: '$18.45M', coi: 0, coll: 14 },
    { id: 'SUP-002', name: 'Summit Insurance Ltd.', cat: 'Insurance', tier: 'Tier 1', reg: 'Verified', perf: 89, value: '$9.20M', coi: 1, coll: 22 },
    { id: 'SUP-003', name: 'Crestline Insurance', cat: 'Insurance', tier: 'Tier 2', reg: 'Verified', perf: 81, value: '$4.10M', coi: 0, coll: 8 },
    { id: 'SUP-004', name: 'ACME Union Motors Ltd.', cat: 'Automotive Parts', tier: 'Tier 2', reg: 'Verified', perf: 76, value: '$67.80M', coi: 2, coll: 55 },
    { id: 'SUP-005', name: 'Meridian Insurance PLC', cat: 'Insurance', tier: 'Tier 1', reg: 'Verified', perf: 85, value: '$6.40M', coi: 0, coll: 30 },
    { id: 'SUP-006', name: 'Pacific Insurance Co.', cat: 'Insurance', tier: 'Tier 2', reg: 'Verified', perf: 54, value: '$2.10M', coi: 3, coll: 81 },
    { id: 'SUP-007', name: 'Sterling Insurance', cat: 'Insurance', tier: 'Tier 1', reg: 'Verified', perf: 88, value: '$5.30M', coi: 0, coll: 12 },
  ];
  const aslRows = asl.map((s, i) => {
    const r = badge(s.reg);
    return {
      ...s,
      zebra: zebra(i),
      regBg: r.bg,
      regFg: r.fg,
      regLabel: L(s.reg, REG_TH[s.reg] ?? s.reg),
      catLabel: L(s.cat, CAT_TH[s.cat] ?? s.cat),
      tierLabel: L(s.tier, s.tier.replace('Tier', 'ระดับ')),
      perfColor: s.perf >= 85 ? 'var(--color-success)' : s.perf >= 70 ? 'var(--color-warning)' : 'var(--color-error)',
      collColor: riskColor(s.coll),
      coiText: s.coi > 0 ? String(s.coi) : '—',
      coiColor: s.coi > 0 ? 'var(--color-error)' : 'var(--color-fg-3)',
      onView: () => go('supplierdetail'),
    };
  });
  const aslFooter = L('Showing 7 of 9 suppliers', 'แสดง 7 จาก 9 ซัพพลายเออร์');

  return (
    <>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 320 }}>
          <Icon name="search" style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-fg-3)', fontSize: 16 }} />
          <input placeholder={L('Search name, ID, Tax ID…', 'ค้นหาชื่อ, รหัส, เลขภาษี…')} style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }} />
        </div>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{L('All categories', 'ทุกหมวดหมู่')}</option>
          <option>{L('Insurance', 'ประกันภัย')}</option>
          <option>{L('Automotive Parts', 'ชิ้นส่วนยานยนต์')}</option>
        </select>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{L('All statuses', 'ทุกสถานะ')}</option>
          <option>{L('Active', 'ใช้งาน')}</option>
          <option>{L('Suspended', 'ระงับ')}</option>
        </select>
      </div>
      <div style={cardPad(0, 'auto')}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 920 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Supplier ID', 'รหัสซัพพลายเออร์')}</th>
              <th style={{ textAlign: 'left', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Name', 'ชื่อ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Category', 'หมวดหมู่')}</th>
              <th style={{ textAlign: 'left', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Tier', 'ระดับ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Registry', 'ทะเบียน')}</th>
              <th style={{ textAlign: 'right', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Perf.', 'ผลงาน')}</th>
              <th style={{ textAlign: 'right', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Total Value', 'มูลค่ารวม')}</th>
              <th style={{ textAlign: 'right', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>COI</th>
              <th style={{ textAlign: 'right', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Collusion', 'การสมรู้ร่วมคิด')}</th>
              <th style={{ textAlign: 'right', padding: '11px 14px', fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Actions', 'การดำเนินการ')}</th>
            </tr>
          </thead>
          <tbody>
            {aslRows.map((s) => (
              <tr key={s.id} style={{ borderBottom: '1px solid var(--color-border)', background: s.zebra }}>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{s.id}</td>
                <td style={{ padding: '12px 14px', fontWeight: 600 }}>{s.name}</td>
                <td style={{ padding: '12px 14px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{s.catLabel}</span>
                </td>
                <td style={{ padding: '12px 14px', color: 'var(--color-fg-2)' }}>{s.tierLabel}</td>
                <td style={{ padding: '12px 14px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: s.regBg, color: s.regFg }}>{s.regLabel}</span>
                </td>
                <td style={{ padding: '12px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 700, color: s.perfColor }}>{s.perf}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)' }}>{s.value}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600, color: s.coiColor }}>{s.coiText}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontFamily: 'var(--font-mono)', fontWeight: 600, color: s.collColor }}>
                    <span style={{ width: 8, height: 8, borderRadius: 999, background: s.collColor }} />{s.coll}
                  </span>
                </td>
                <td style={{ padding: '12px 14px', textAlign: 'right' }}>
                  <button onClick={s.onView} className="hv-ink" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--color-border-strong)', background: 'var(--color-white)', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                    <Icon name="eye" />{L('View', 'ดู')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ padding: '12px 16px', fontSize: 12, color: 'var(--color-fg-3)', borderTop: '1px solid var(--color-border)' }}>{aslFooter}</div>
      </div>
    </>
  );
}
